import { UserRole } from "../access-rights/user-roles";
import { OAuthService } from "./oauth-service";
export class OAuthViewModel {
    store;
    service;
    name = this.constructor.name;
    constructor(store, service) {
        this.store = store;
        this.service = service;
    }
    get userName() {
        return this.store.jwtUser?.name ?? "";
    }
    get userEmail() {
        return this.store.jwtUser?.unique_name ?? "";
    }
    isLoggedIn() {
        return this.store.accessToken !== null;
    }
    get isOAuthEnabled() {
        return OAuthService.isOAuthEnabled;
    }
    get roles() {
        return this.store.jwtUser?.roles ?? [UserRole.READONLY];
    }
    hasAnyRole(roles) {
        const userRoles = this.roles;
        return roles.some((r) => userRoles.includes(r));
    }
    async generateRedirectUri() {
        return await this.service.prepareOAuthRedirectURLwithPKCE();
    }
    async exchangeCodeForToken(code) {
        if (!code) {
            console.error("OAuth Code is empty");
            return;
        }
        await this.service.exchangeCodeForToken(code);
    }
    logout() {
        this.store.clearToken();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    notifyLocationChanged(route, params) {
    }
}
